exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,700&display=swap);", ""]);

// module
exports.push([module.id, "/* This needs to be imported from an actual css file (not in a styled-components global), due to\n * https://github.com/styled-components/styled-components/issues/2911 */\n\nbody {\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  letter-spacing: 0.25px;\n  font-weight: 300;\n  line-height: 1.5;\n}\n", ""]);

// exports
